import { __decorate, __extends } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import CategorizeBox from "@/components/categorizeBox/index.vue";
import FormPage from "./addEditCopy/index.vue";

var GPSRInfoUpdatePage = function (_super) {
  __extends(GPSRInfoUpdatePage, _super);

  function GPSRInfoUpdatePage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GPSRInfoUpdatePage.prototype.created = function () {};

  GPSRInfoUpdatePage = __decorate([Component({
    components: {
      CategorizeBox: CategorizeBox,
      FormPage: FormPage
    }
  })], GPSRInfoUpdatePage);
  return GPSRInfoUpdatePage;
}(Vue);

export default GPSRInfoUpdatePage;